import React from 'react';
import PagosCreditoTable from './TablePagosCredito/TablePagosCredito';

const PagosCredito = () => {
  return <PagosCreditoTable/> ;
};

export default PagosCredito;
